import React from 'react';

let prev = -1;
class ScrollView extends React.Component {
	trackScrolling = (cb, gap = 0.2) => (e) => {
		  const bottom = e.target.scrollHeight - e.target.scrollTop < (e.target.clientHeight + (e.target.clientHeight * gap));
		  
		//   const current = e.target.scrollHeight - e.target.scrollTop
		//   console.log('ScrollView: scrollHeight =', e.target.scrollHeight)
		//   console.log('ScrollView: scrollTop =', e.target.scrollTop)
		//   console.log('ScrollView: clientHeight =', e.target.clientHeight)
		//   console.log('ScrollView: scrollHeight - scrollTop =', e.target.scrollHeight - e.target.scrollTop)
		//   console.log('ScrollView: gap =', gap)
		//   console.log('Scrollview: clientHeight + (clientHeight * gap) =', e.target.clientHeight + (e.target.clientHeight * gap))
		//   console.log('ScrollView: scrollHeight - scrollTop < (clientHeight + (clientHeight * gap) =', e.target.scrollHeight - e.target.scrollTop < (e.target.clientHeight + (e.target.clientHeight * gap)))
		//   console.log('ScrollView: ******************************************************************')

  		if (bottom) {
			if (cb) cb();
		} 
		
		prev = e.target.scrollHeight - e.target.scrollTop;
  	};

	render() {
		const { children, onBottom, gap, ...rest } = this.props;

		return (
			<div
				onScroll={this.trackScrolling(onBottom, gap)}
				{...rest}
			>
				{children}
			</div>
		);
	}
}

export default ScrollView;